import { Directive, HostListener } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Directive({
  selector: '[closeOnEsc]'
})
export class CloseOnEscDirective {

  constructor(private tooltipDirective: TooltipDirective) {}

  @HostListener('document:keyup.escape')
  onEscapeKeyUp() {
    if (this.tooltipDirective.isOpen) {
      this.tooltipDirective.hide();
    }
  }
  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    if (this.tooltipDirective && this.tooltipDirective.isOpen) {
      const tooltipContent = document.querySelector('.tooltip-inner');
      const focus = tooltipContent && tooltipContent.hasAttribute('tabIndex');
      focus ?
        setTimeout(() => {
          this.tooltipDirective.hide();
        }, 5000) : this.tooltipDirective.hide();

    }
  }

  @HostListener('keyup.enter', ['$event'])
  onKeyUpEnter(event: KeyboardEvent) {
    if (this.tooltipDirective && !this.tooltipDirective.isOpen) {
      this.tooltipDirective.show();
      setTimeout(() => {
        const tooltipContent = document.querySelector('.tooltip-inner');
        if (tooltipContent) {
          tooltipContent.setAttribute('tabIndex', '0');
        }
      }, 1000);

    }
  }
}